export enum CCMS_PROGRAM_TYPE_ENUMS {
  familyChildCare = 'familyChildCare',
  childCareCenter = 'childCareCenter',
  microSchool = 'microSchool',
  forestSchool = 'forestSchool',
  ministry = 'ministry',
  exempt = 'exempt',
  other = 'other',
}

export const PROGRAM_TYPES = [
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.familyChildCare,
    label: 'Family Child Care',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.childCareCenter,
    label: 'Child Care Center',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.microSchool,
    label: 'Micro School',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.forestSchool,
    label: 'Forest School',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.ministry,
    label: 'Ministry',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.exempt,
    label: 'Exempt',
  },
  {
    value: CCMS_PROGRAM_TYPE_ENUMS.other,
    label: 'Other',
  },
];
